import component from './ru-RU/component';
import globalHeader from './ru-RU/globalHeader';
import menu from './ru-RU/menu';
import pages from './ru-RU/pages';
import entities from './ru-RU/entities';
import pwa from './ru-RU/pwa';
import permissions from './ru-RU/permissions';
import settingDrawer from './ru-RU/settingDrawer';
import settings from './ru-RU/settings';

export default {
  'navBar.lang': 'Язык',
  'layout.header.workspace': 'Рабочий кабинет методиста',
  'layout.user.link.help': 'Помощь',
  'layout.user.link.privacy': 'Конфиденциальность',
  'layout.user.link.terms': 'Условия',
  'app.copyright.produced': 'Разработано AI Dovut',
  'app.preview.down.block': 'Скачать проект',
  'app.welcome.link.fetch-blocks': 'Получить все блоки',
  'app.welcome.link.block-list': 'Быстрая разработка',
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...pages,
  ...entities,
  ...permissions,
};
